export interface Sort {
  field: string;
  order: string;
  value: string;
}

export const defaultSort: Sort = { field: "created_at", order: "desc", value: "dateDesc" };
